export const getIcon = (slug: string) => {
	switch (slug) {
		case 'beach-resorts':
			return 'beach-resorts'
		case 'cruises':
			return 'cruise'
		case 'theme-parks':
			return 'theme-parks'
	}
}
